module.exports = __webpack_public_path__ + "static/media/StandingTall.f609f28e.jpg";